<template>
  <div class="two-step-verify">
    <div class="two-step-content">
      <header slot="header" class="two-step-header">
        <div class="title">
          {{ $t('settings.dynamic-password-title') }}
          {{ $t('settings.dynamic-password-prompt') }}
        </div>
      </header>
      <section slot="body" class="two-step-body">
        <EncryptCode ref="encrypt" v-model="password" @done="submitHandler" />
        <ErrorTips v-if="error" :value="error" />
      </section>
      <footer slot="footer" class="two-step-footer">
        <Button class="button" theme="primary" @click="submitHandler">
          {{ $t('confirm') }}
        </Button>
        <Button class="button" @click="close()">
          {{ $t('cancel') }}
        </Button>
      </footer>
      <div class="two-step-has-problem" @click="showTips">
        {{ $t('settings.cannot-verify') }}
      </div>
    </div>
  </div>
</template>
<script>
import nprogress from 'nprogress'
import { ERROR_CODE } from 'const/common'
import Icon from 'com/Icon'
import EncryptCode from 'com/EncryptCode'
import Button from 'com/Button'
import ErrorTips from './ErrorTips'
export default {
  name: 'TwoStepVerify',
  components: { ErrorTips, EncryptCode, Icon, Button },
  data: () => ({
    password: '',
    error: null
  }),
  inject: ['$panel'],
  props: {
    type: String,
    params: [String, Object]
  },
  mounted() {
    this.$el.addEventListener('click', e => {
      this.$refs.encrypt.focus()
    })
  },
  methods: {
    submitHandler() {
      nprogress.start()
      this.error = ''
      const { action, ...params } = this.params
      params.otp_code = this.password
      delete params.captcha_code
      this.$store
        .dispatch(action, params)
        .then(
          tokenObj => {
            this.close(tokenObj)
          },
          err => {
            this.password = ''
            if (err.error_code === ERROR_CODE.OTP_ERROR) {
              this.error = this.$t('settings.dynamic-password-error')
            } else {
              this.error = err.error_description
            }
          }
        )
        .finally(() => nprogress.done())
    },
    showTips() {
      this.$panel.showConfirm({
        content: this.$t('settings.tip-help'),
        okText: this.$t('settings.re-login'),
        ok: () => {
          this.close()
        }
      })
    },
    close(value) {
      this.$emit('closeTwoStep', value)
    }
  }
}
</script>

<style lang="less" scoped>
@import '~uikit';
.two-step-verify {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: white;
  border-radius: 8px;
  z-index: 2;
  .two-step-content {
    padding: 20px;
  }
  .two-step-header {
    display: flex;
    flex-direction: column;
    font-size: 14px;
    margin-bottom: 30px;
    color: @special-grey;
    span {
      margin-top: 15px;
    }
    .title {
      font-size: 14px;
      &.warning {
        .first-title {
          padding-bottom: 10px;
          color: var(--login-active-color);
        }
        .sub-title {
          font-size: 14px;
        }
      }
    }
  }
  .error-message {
    display: flex;
    align-items: center;
    color: var(--red);
    margin-top: 3px;
    .error-icon {
      width: 12px;
      height: 12px;
      margin-right: 3px;
    }
  }
  .two-step-body {
    width: 240px;
    margin: 0 auto 60px;
  }
  .two-step-footer {
    line-height: 60px;
    text-align: center;
    button:last-of-type {
      margin-left: 20px;
    }
  }
  .two-step-has-problem {
    position: absolute;
    bottom: 30px;
    left: 0;
    right: 0;
    cursor: pointer;
    color: @light-grey;
    text-align: center;
  }
}
</style>
